@let error = errorMessageService.error();
@if (error) {
  <div class="toast toast-bottom toast-center">
    <div class="alert alert-error">
      {{ error | translate }}
    </div>
  </div>
}
